/* Studio VormVezel – gedrag voor het nieuwe ontwerp (layout vv). Geen afhankelijkheden. */
(function () {
  'use strict';
  var D = document;
  function $(s, r) { return (r || D).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || D).querySelectorAll(s)); }
  var reduced = false;
  try { reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  /* Vertaalbare teksten uit Thema-instellingen › VormVezel (layout/vv.liquid zet ze in window.vvT) */
  function T(k, d) { var t = window.vvT && window.vvT[k]; return t || d; }
  function saveData() { try { return !!(navigator.connection && navigator.connection.saveData); } catch (e) { return false; } }
  /* Voorlezen via #vv-live; komen er twee meldingen vlak na elkaar (bijv. "toegevoegd" en "cadeau toegevoegd"), dan beide */
  var annLast = '', annAt = 0;
  function announce(t) {
    var l = $('#vv-live'); if (!l || !t) return;
    var now = Date.now();
    if (annLast && now - annAt < 1500 && annLast.indexOf(t) < 0 && t.indexOf(annLast) < 0) t = annLast + ' ' + t;
    annLast = t; annAt = now;
    l.textContent = ''; setTimeout(function () { l.textContent = t; }, 40);
  }
  /* Bedragen tonen. Winkelvaluta (euro): zoals altijd '€12,34'. Andere valuta (bijv. SEK, DKK via Markten): de notatie van
     Shopify, afgeleid van een voorbeeldbedrag op de winkelwagenlade (data-money = 123456 | money, data-fx-cur, data-shop-cur). */
  var moneyF = null;
  function moneyFmt() {
    if (moneyF !== null) return moneyF;
    moneyF = false;
    var dr = D.querySelector('[data-vv-drawer]');
    var cur = dr && dr.getAttribute('data-fx-cur'), base = dr && dr.getAttribute('data-shop-cur'), smp = dr && dr.getAttribute('data-money');
    if (!cur || !base || cur === base || !smp) return moneyF;
    var i = smp.search(/\d/), j = -1;
    for (var k = smp.length - 1; k >= 0; k--) { if (/\d/.test(smp.charAt(k))) { j = k; break; } }
    if (i < 0 || j < 0) return moneyF;
    var mid = smp.slice(i, j + 1), m = mid.match(/^1(\D?)234(\D)56$/), n = m ? null : mid.match(/^1(\D?)23[45]$/);
    if (m) moneyF = { pre: smp.slice(0, i), post: smp.slice(j + 1), th: m[1], dec: m[2] };
    else if (n) moneyF = { pre: smp.slice(0, i), post: smp.slice(j + 1), th: n[1], dec: '' };
    return moneyF;
  }
  function money(cents) {
    var f = moneyFmt();
    if (!f) return '€' + (cents / 100).toFixed(2).replace('.', ',');
    var neg = cents < 0, s = (Math.abs(cents) / 100).toFixed(f.dec ? 2 : 0).split('.');
    return (neg ? '-' : '') + f.pre + s[0].replace(/\B(?=(\d{3})+(?!\d))/g, f.th) + (f.dec ? f.dec + s[1] : '') + f.post;
  }

  /* ---------- Kop: schaduw bij scrollen (de kop opnieuw opzoeken: na herladen in de thema-editor is het een nieuw element) ---------- */
  function onScroll() { var hdr = $('.hdr'); if (hdr) hdr.classList.toggle('scrolled', (window.scrollY || window.pageYOffset) > 4); }
  window.addEventListener('scroll', onScroll, { passive: true }); onScroll();

  /* ---------- Aankondigingsbalk: wisselende berichten ---------- */
  var annTimer = null;
  function initAnn() {
    if (annTimer) { clearInterval(annTimer); annTimer = null; }
    var ann = $('#ann'); if (!ann) return;
    var items = $$('.ann-rot span', ann), i = 0, paused = false;
    if (reduced || items.length < 2) return;
    ann.addEventListener('mouseenter', function () { paused = true; });
    ann.addEventListener('mouseleave', function () { paused = false; });
    ann.addEventListener('focusin', function () { paused = true; });
    ann.addEventListener('focusout', function () { paused = false; });
    var sec = Math.max(3, Math.min(10, parseInt(ann.getAttribute('data-interval'), 10) || 5));
    annTimer = setInterval(function () { if (paused || D.hidden || !ann.isConnected) return; items[i].classList.remove('on'); i = (i + 1) % items.length; items[i].classList.add('on'); }, sec * 1000);
  }
  initAnn();

  /* ---------- Fotootjes in de menu's: pas laden als het uitklapmenu of het mobiele menu opengaat ----------
     (de kop zet de adressen in data-vv-src / data-vv-srcset; zo kosten ze niets zolang het menu dicht is) */
  function loadThumbs(root) {
    if (!root || !root.querySelectorAll) return;
    $$('source[data-vv-srcset]', root).forEach(function (so) {
      so.setAttribute('srcset', so.getAttribute('data-vv-srcset')); so.removeAttribute('data-vv-srcset');
    });
    $$('img[data-vv-src]', root).forEach(function (im) {
      var ss = im.getAttribute('data-vv-srcset');
      if (ss) { im.setAttribute('srcset', ss); im.removeAttribute('data-vv-srcset'); }
      im.setAttribute('src', im.getAttribute('data-vv-src')); im.removeAttribute('data-vv-src');
    });
  }
  function ddPanel(b) { return $('#' + b.getAttribute('aria-controls')) || b.nextElementSibling; }
  /* alvast laden zodra de muis of de focus op de knop komt, zodat het paneel bij openen meteen compleet is */
  function ddPrefetch(e) { var b = e.target.closest && e.target.closest('.dd-btn'); if (b) loadThumbs(ddPanel(b)); }
  D.addEventListener('mouseover', ddPrefetch, { passive: true });
  D.addEventListener('focusin', ddPrefetch);

  /* ---------- Uitklapmenu "Vazen" in de kop ---------- */
  D.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.dd-btn');
    var open = $$('.dd-btn[aria-expanded="true"]');
    if (b) {
      var p = ddPanel(b);
      var o = b.getAttribute('aria-expanded') === 'true';
      if (!o) loadThumbs(p);
      b.setAttribute('aria-expanded', String(!o)); if (p) p.hidden = o;
      return;
    }
    open.forEach(function (x) { if (!x.parentNode.contains(e.target)) { x.setAttribute('aria-expanded', 'false'); var p = $('#' + x.getAttribute('aria-controls')) || x.nextElementSibling; if (p) p.hidden = true; } });
  });
  function ddClose(b, focus) { b.setAttribute('aria-expanded', 'false'); var p = $('#' + b.getAttribute('aria-controls')) || b.nextElementSibling; if (p) p.hidden = true; if (focus) b.focus(); }
  /* Escape sluit het uitklapmenu (focus terug op de knop); met Tab uit het menu gaan sluit het ook */
  D.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || stack.length) return;
    $$('.dd-btn[aria-expanded="true"]').forEach(function (b) { ddClose(b, b.parentNode.contains(D.activeElement)); });
  });
  D.addEventListener('focusout', function (e) {
    var dd = e.target.closest && e.target.closest('.dd'); if (!dd || !e.relatedTarget || dd.contains(e.relatedTarget)) return;
    var b = dd.querySelector('.dd-btn[aria-expanded="true"]'); if (b) ddClose(b, false);
  });

  /* ---------- Lades en panelen (menu, maatadvies, winkelwagen): data-open="id" / data-close ---------- */
  var stack = [];
  var giftGone = { drawer: false, page: false };
  /* Knoppen die dit paneel openen en aria-expanded hebben (zoals de menuknop, aria-controls="menu"): open/dicht melden aan schermlezers */
  function syncExpanded(el, open) {
    if (!el || !el.id) return;
    $$('[data-open="' + el.id + '"][aria-expanded]').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
  }
  function openPanel(el, opener) {
    if (!el) return;
    loadThumbs(el);
    el.hidden = false; el.classList.add('open'); stack.push({ el: el, opener: opener });
    syncExpanded(el, true);
    D.documentElement.style.overflow = 'hidden'; D.documentElement.classList.add('vv-modal-open');
    var sel = 'a[href],button:not([disabled]),input,select,textarea';
    var f = el.querySelector('[data-autofocus]') || el.querySelector(sel);
    /* Zoekveld (data-focus-now): de focus meteen, in dezelfde klik, zodat de iPhone het toetsenbord opent */
    if (f && f.hasAttribute('data-focus-now')) { try { f.focus({ preventScroll: true }); } catch (x) { f.focus(); } }
    /* opnieuw zoeken als de inhoud intussen vervangen is (de lade wordt bij openen bijgewerkt) */
    if (f) setTimeout(function () { if (f.isConnected === false) f = el.querySelector('[data-autofocus]') || el.querySelector(sel); if (f) f.focus({ preventScroll: true }); }, 40);
    var ov = $('#overlay'); if (ov) ov.classList.add('show');
    var site = $('#site'); if (site) site.inert = true;
  }
  /* noFocus (optioneel): focus niet terugzetten, bijv. omdat direct daarna de winkelwagenlade opent */
  function closeTop(noFocus) {
    var t = stack.pop(); if (!t) return;
    t.el.classList.remove('open');
    if (!inStack(t.el)) syncExpanded(t.el, false);
    if (t.el.hasAttribute('data-hide-closed')) setTimeout(function () { if (!t.el.classList.contains('open')) t.el.hidden = true; }, 250);
    /* Winkelwagenlade: de melding "cadeau weer verwijderd" alleen tonen tot de lade sluit (zoals de demo) */
    if (t.el.hasAttribute('data-vv-drawer')) { giftGone.drawer = false; var gn = t.el.querySelector('[data-gift-notice]'); if (gn) gn.hidden = true; }
    if (!stack.length) { D.documentElement.style.overflow = ''; D.documentElement.classList.remove('vv-modal-open'); var ov = $('#overlay'); if (ov) ov.classList.remove('show'); var site = $('#site'); if (site) site.inert = false; }
    if (noFocus !== true && t.opener && t.opener.focus && t.opener.isConnected !== false) t.opener.focus({ preventScroll: true });
    /* Melden dat dit paneel dicht is (het zoekpaneel ruimt dan zijn stap in de geschiedenis op, assets/vv-search.js) */
    try { t.el.dispatchEvent(new CustomEvent('vv:close', { detail: { noFocus: noFocus === true } })); } catch (x) {}
  }
  D.addEventListener('click', function (e) {
    var t = e.target; if (!t.closest) return;
    var op = t.closest('[data-open]');
    if (op) { e.preventDefault(); openPanel(D.getElementById(op.getAttribute('data-open')), op); return; }
    if (t.closest('[data-close]') || t.id === 'overlay') { e.preventDefault(); closeTop(); }
  });
  D.addEventListener('keydown', function (e) { if (e.key === 'Escape' && stack.length) closeTop(); });
  /* Tab en Shift+Tab blijven in de bovenste lade of het bovenste paneel (demo: focus trap). Zonder dit gaat de focus naar
     de app-knoppen buiten #site (WebwinkelKeur, Google-badge) of naar de adresbalk. */
  function focusables(el) {
    return $$('a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex]', el)
      .filter(function (x) { return x.tabIndex >= 0 && x.getClientRects().length > 0 && getComputedStyle(x).visibility !== 'hidden'; });
  }
  D.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !stack.length) return;
    var el = stack[stack.length - 1].el, f = focusables(el);
    if (!f.length) { e.preventDefault(); return; }
    var first = f[0], last = f[f.length - 1], ae = D.activeElement;
    if (!el.contains(ae)) { e.preventDefault(); (e.shiftKey ? last : first).focus(); }
    /* ook als de focus op iets staat dat zelf niet met Tab bereikbaar is (bijv. de titel na verwijderen) vóór de eerste of na de laatste knop */
    else if (e.shiftKey && (ae === first || ae === el || (f.indexOf(ae) < 0 && (ae.compareDocumentPosition(first) & 4)))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (ae === last || (f.indexOf(ae) < 0 && (last.compareDocumentPosition(ae) & 4)))) { e.preventDefault(); first.focus(); }
  });

  /* ---------- Video's: automatisch afspelen als ze in beeld zijn (niet bij minder beweging of databesparing) ---------- */
  var vidVis = [];
  function vidAllowed(v) {
    if (v._u === 'pause') return false;
    if (v._u === 'play') return true;
    if (reduced || saveData()) return false;
    return true;
  }
  function setPoster(v) { var p = v.getAttribute('data-poster'); if (p && !v.getAttribute('poster')) v.setAttribute('poster', p); }
  function vidPlay(v) { setPoster(v); v.muted = true; var pr = null; try { pr = v.play(); } catch (e) {} if (pr && pr.catch) pr.catch(function () {}); }
  function vidSync(v) {
    var b = v.parentNode && v.parentNode.querySelector('[data-vid]'); if (!b) return;
    var on = !v.paused, nm = b.getAttribute('data-name');
    b.setAttribute('aria-label', (on ? T('videoPause', 'Video pauzeren') : T('videoPlay', 'Video afspelen')) + (nm ? ': ' + nm : ''));
    var u = b.querySelector('use'); if (u) u.setAttribute('href', on ? '#i-pause' : '#i-play');
  }
  function vidCheck(v) { if (vidVis.indexOf(v) > -1 && vidAllowed(v) && !D.hidden) { if (v.paused) vidPlay(v); } else if (!v.paused) v.pause(); }
  function initVideos(root) {
    var vs = $$('video[data-auto]', root).filter(function (v) { return !v._b; });
    vs.forEach(function (v) { v._b = true; v.muted = true; v.addEventListener('play', function () { vidSync(v); }); v.addEventListener('pause', function () { vidSync(v); }); vidSync(v); });
    if (!('IntersectionObserver' in window)) { vs.forEach(function (v) { setPoster(v); vidVis.push(v); vidCheck(v); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        var v = en.target, i = vidVis.indexOf(v);
        if (en.isIntersecting && en.intersectionRatio >= 0.2) { if (i < 0) vidVis.push(v); } else if (i > -1) vidVis.splice(i, 1);
        if (en.isIntersecting) setPoster(v);
        vidCheck(v);
      });
    }, { threshold: [0, 0.2, 0.5], rootMargin: '200px 0px' });
    vs.forEach(function (v) { io.observe(v); });
  }
  D.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-vid]'); if (!b) return;
    var v = b.parentNode.querySelector('video'); if (!v) return;
    if (v.paused) { v._u = 'play'; vidPlay(v); } else { v._u = 'pause'; v.pause(); }
  });
  D.addEventListener('visibilitychange', function () { vidVis.slice().forEach(vidCheck); });
  initVideos(D);

  /* ---------- Draaivideo's: iPhone, iPad en Safari op de Mac krijgen de 'a'-versie (zelfde kleur als op andere apparaten) ---------- */
  var APPLE = (function () {
    var u = navigator.userAgent || '';
    if (/iPhone|iPad|iPod/.test(u)) return true;
    if (/Macintosh/.test(u) && navigator.maxTouchPoints > 1) return true;
    return /Safari\//.test(u) && !/Chrome|Chromium|CriOS|Edg|OPR|Firefox|FxiOS|Android/.test(u);
  })();
  D.documentElement.classList.toggle('vv-apple', APPLE);
  /* Kies per element de juiste bron: data-spin-src / data-spin-src-apple (ook op <video> en <source>) */
  function spinSrc(el) { return (APPLE && el.getAttribute('data-spin-src-apple')) || el.getAttribute('data-spin-src') || ''; }
  function initSpinVideos(root) {
    $$('video[data-spin-src]', root).forEach(function (v) {
      if (v._spin) return; v._spin = true;
      var s = spinSrc(v); if (s && v.getAttribute('src') !== s) { v.setAttribute('src', s); try { v.load(); } catch (e) {} }
    });
  }
  initSpinVideos(D);

  /* ---------- Kaarten op desktop: draaiende vaas (data-spin) of tweede foto (data-hover) bij aanwijzen ---------- */
  function swapOn(el) { var on = ''; try { on = getComputedStyle(el).getPropertyValue('--swap').trim(); } catch (x) {} return on === '1'; }
  function playQuiet(v) { var pr = null; try { pr = v.play(); } catch (x) {} if (pr && pr.catch) pr.catch(function () {}); }
  D.addEventListener('mouseover', function (e) {
    var card = e.target.closest && e.target.closest('.card'); if (!card) return;
    var sp = card.classList.contains('is-out') ? null : card.querySelector('.card-media[data-spin]');
    if (sp && spinSrc(sp) && !reduced && !saveData()) {
      if (!swapOn(sp)) return;
      var ov = sp.querySelector('video.card-alt');
      if (!ov) {
        ov = D.createElement('video'); ov.className = 'card-alt card-spin'; ov.muted = true; ov.loop = true; ov.playsInline = true;
        ov.setAttribute('playsinline', ''); ov.setAttribute('aria-hidden', 'true'); ov.preload = 'auto';
        ov.addEventListener('playing', function () { ov.classList.add('ready'); });
        ov.src = spinSrc(sp);
        var mi = sp.querySelector('img'); if (mi && mi.nextSibling) sp.insertBefore(ov, mi.nextSibling); else sp.appendChild(ov);
        card.addEventListener('mouseleave', function () { ov.pause(); });
        card.addEventListener('mouseenter', function () { if (!reduced && swapOn(sp)) playQuiet(ov); });
      }
      if (ov.paused) playQuiet(ov);
      return;
    }
    /* ook voor draaivazen bij minder beweging of databesparing */
    var cm = card.querySelector('.card-media[data-hover]'); if (!cm || cm.querySelector('.card-alt')) return;
    if (!swapOn(cm)) return;
    var im = D.createElement('img'); im.className = 'card-alt'; im.alt = ''; im.decoding = 'async';
    im.onload = function () { im.classList.add('ready'); };
    if (cm.getAttribute('data-hover-srcset')) { im.srcset = cm.getAttribute('data-hover-srcset'); im.sizes = '(min-width: 1024px) 290px, 50vw'; }
    im.src = cm.getAttribute('data-hover');
    var main = cm.querySelector('img'); if (main && main.nextSibling) cm.insertBefore(im, main.nextSibling); else cm.appendChild(im);
  });

  /* ---------- Winkelwagenlade (sections/vv-cart-drawer.liquid, demo #drawer) ----------
     #drawer[data-vv-drawer] staat (na moveLayers) in #layers. Openen: winkelwagenknop [data-cart-open], na toevoegen
     (refreshCart(true) / addToCart) en vanuit andere scripts met window.vv.openCart(). Na elke wijziging haalt vv.js de
     sectie opnieuw op met de Section Rendering API (/?sections=vv-cart-drawer), zodat bedragen, korting en cadeau altijd van
     Shopify komen. Zonder de sectie valt alles terug op Slide Cart (SLIDECART_*) of op /cart. */
  var DRAWER_SID = 'vv-cart-drawer';
  function drawer() { return $('#layers [data-vv-drawer]') || $('[data-vv-drawer]'); }
  function inStack(el) { for (var i = 0; i < stack.length; i++) { if (stack[i].el === el) return true; } return false; }
  function openDrawer(opener) {
    var dr = drawer(); if (!dr) return false;
    if (!dr.parentNode || dr.parentNode.id !== 'layers') { moveLayers(); dr = drawer(); }
    if (inStack(dr)) return true;
    openPanel(dr, (opener && opener.nodeType === 1) ? opener : D.activeElement);
    return true;
  }
  function postJSON(url, body) {
    return fetch(rootUrl() + url, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  /* Foutmelding voor de klant: alleen een melding van Shopify over de voorraad (description, bijv. 'Er zijn slechts 5 artikelen
     aan je winkelwagen toegevoegd vanwege beschikbaarheid.' of 'De maximale hoeveelheid van dit artikel zit al in je
     winkelwagen.'), anders de Nederlandse standaardtekst d. Nooit err.message ('Failed to fetch', een JSON-fout bij een
     storingspagina) en geen technische Shopify-melding ('geen geldige ID of regelnummer' bij een verouderde regelsleutel,
     'Cannot find variant', 'expected String … : id'). */
  function errText(err, d) {
    var t = err && err.description;
    if (typeof t !== 'string' || !/voorraad|uitverkocht|beschikbaar|slechts|maxim|niet meer/i.test(t) ||
      /geldig|regelnummer|\bid\b|parameter|expected|error|cannot|invalid/i.test(t)) return d || '';
    return t;
  }
  function getCart() {
    return fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw r; return r.json(); });
  }
  function fetchDrawer() {
    return fetch(rootUrl() + '?sections=' + DRAWER_SID, { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function (j) { return j ? j[DRAWER_SID] : null; });
  }
  /* Knop met data-fk terugvinden na verversen. Shopify geeft een regel een nieuwe sleutel ("variant:hash") als de korting
     verandert (bijv. als het cadeau erbij komt); dan zoeken we dezelfde knop bij dezelfde variant. */
  function fkFind(root, fk) {
    if (!root || !fk) return null;
    fk = String(fk).replace(/"/g, '');
    var el = root.querySelector('[data-fk="' + fk + '"]'); if (el) return el;
    var m = fk.match(/^(\d+):[^|]*(\|.*)$/); if (!m) return null;
    var all = root.querySelectorAll('[data-fk^="' + m[1] + ':"]');
    for (var i = 0; i < all.length; i++) { var v = all[i].getAttribute('data-fk'); if (v.slice(-m[2].length) === m[2]) return all[i]; }
    return null;
  }
  /* De nieuwe inhoud in de bestaande lade zetten (die blijft open); focus en scrollpositie blijven waar ze waren */
  function drawerRender(html, msg) {
    var dr = drawer(); if (!dr || !html) return null;
    var tmp = D.createElement('div'); tmp.innerHTML = html;
    var fresh = tmp.querySelector('[data-vv-drawer]'); if (!fresh) return null;
    var ae = D.activeElement, inside = !!(ae && ae !== dr && dr.contains(ae));
    var fk = inside && ae.getAttribute ? ae.getAttribute('data-fk') : null;
    var body = dr.querySelector('.dr-body'), top = body ? body.scrollTop : 0;
    var keep = { 'class': 1, hidden: 1, style: 1, 'aria-busy': 1 };
    Array.prototype.slice.call(dr.attributes).forEach(function (a) { if (!keep[a.name] && !fresh.hasAttribute(a.name)) dr.removeAttribute(a.name); });
    Array.prototype.slice.call(fresh.attributes).forEach(function (a) { if (!keep[a.name]) dr.setAttribute(a.name, a.value); });
    dr.innerHTML = fresh.innerHTML;
    var nb = dr.querySelector('.dr-body'); if (nb && top) nb.scrollTop = top;
    /* Melding "cadeau weer verwijderd" alleen zolang het cadeaubedrag niet (opnieuw) bereikt is */
    if (dr.getAttribute('data-gift-reached') === '1') giftGone.drawer = false;
    var gn = dr.querySelector('[data-gift-notice]');
    if (gn && giftGone.drawer) { gn.hidden = false; if (msg && gn.textContent && msg.indexOf(gn.textContent) < 0) msg = msg + ' ' + gn.textContent; }
    if (inside) {
      var el = fkFind(dr, fk);
      if (!el || el.disabled) el = dr.querySelector('#dr-title') || dr.querySelector('[data-close]');
      if (el && el.focus) { try { el.focus({ preventScroll: true }); } catch (x) { el.focus(); } }
    }
    if (msg) announce(msg);
    return dr;
  }

  /* ---------- Cadeau (demo GIFT_MIN): vanaf het bedrag 1 cadeau erbij, eronder weer weg ----------
     Alleen de regel met de eigenschap _vv_cadeau = 1 wordt beheerd; een zelf gekochte sleutelhanger nooit. De korting in Shopify
     maakt het cadeau gratis. Geeft de korting het cadeau toch niet gratis (bijv. de producten tellen niet mee voor de korting),
     dan halen we het weer weg en proberen we het pas opnieuw als het subtotaal verandert (sessionStorage vv-gift-block).
     Werkt sessionStorage niet (uitgezet, vol), dan onthouden we het in het geheugen (giftBlockMem) voor deze pagina. */
  function isGiftLine(it) { return !!(it && it.properties && it.properties._vv_cadeau); }
  var giftBlockMem = null;
  function giftBlocked(base) { if (giftBlockMem === String(base)) return true; try { return sessionStorage.getItem('vv-gift-block') === String(base); } catch (e) { return false; } }
  function giftBlock(base) { giftBlockMem = String(base); try { sessionStorage.setItem('vv-gift-block', String(base)); } catch (e) {} }
  function giftPlan(cart) {
    var dr = drawer(); if (!dr || !cart || !cart.items) return null;
    var pid = dr.getAttribute('data-gift-product') || '', vid = dr.getAttribute('data-gift-variant') || '';
    var min = parseInt(dr.getAttribute('data-gift-min'), 10) || 0, b2b = dr.getAttribute('data-b2b') === '1';
    var mine = cart.items.filter(isGiftLine);
    var base = (cart.items_subtotal_price || 0) - mine.reduce(function (a, it) { return a + (it.final_line_price || 0); }, 0);
    var otherFree = cart.items.some(function (it) { return !isGiftLine(it) && pid && String(it.product_id) === pid && it.final_line_price < it.original_line_price; });
    var want = !b2b && min > 0 && !!vid && base >= min;
    if (!want) return mine.length ? { remove: mine, gone: !b2b && min > 0 && base < min && base > 0 } : null;
    if (mine.length > 1) return { remove: mine.slice(1) };
    if (mine.length === 1) {
      if (mine[0].quantity !== 1) return { qty: mine[0] };
      if (mine[0].final_line_price > 0 && !otherFree) { giftBlock(base); return { remove: mine }; }
      return null;
    }
    if (otherFree || giftBlocked(base)) return null;
    return { add: Number(vid) };
  }
  function giftApply(plan) {
    if (plan.add) return postJSON('cart/add.js', { items: [{ id: plan.add, quantity: 1, properties: { _vv_cadeau: '1' } }] });
    if (plan.qty) return postJSON('cart/change.js', { id: plan.qty.key, quantity: 1 });
    var upd = {}; plan.remove.forEach(function (it) { upd[it.key] = 0; });
    return postJSON('cart/update.js', { updates: upd });
  }

  /* ---------- Winkelwagen: tellertje, cadeau, lade bijwerken (en openen) ----------
     refreshCart(open, msg): open = true of het element dat de lade opende (focus gaat daar na sluiten naartoe).
     Aanroepen worden na elkaar uitgevoerd, zodat het cadeau nooit dubbel wordt toegevoegd. */
  var cartQueue = null;
  /* cartPending telt lopende winkelwagenacties (verversen, wijzigen in de lade of op /cart); whenCartIdle(f) voert f uit
     zodra er niets meer loopt (bijv. afrekenen pas als het cadeau is weggehaald) */
  var cartPending = 0, cartIdle = [];
  function cartWork(p) {
    cartPending++;
    var done = function () { cartPending--; if (cartPending > 0) return; var w = cartIdle; cartIdle = []; w.forEach(function (f) { f(); }); };
    p.then(done, done);
    return p;
  }
  function whenCartIdle(f) { if (cartPending > 0) cartIdle.push(f); else f(); }
  function refreshCart(open, msg) {
    var opener = open ? ((open.nodeType === 1) ? open : D.activeElement) : null;
    var run = function () { return doRefresh(open, opener, msg); };
    var p = cartQueue ? cartQueue.then(run, run) : run();
    cartQueue = p.then(function () {}, function () {});
    return cartWork(p);
  }
  function doRefresh(open, opener, msg) {
    var dr = drawer(), passes = 0, giftMsg = '';
    function finish(cart, html) {
      $$('[data-cart-count], .cart-count').forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
      $$('.cart-btn[data-label]').forEach(function (a) { var n = cart.item_count; a.setAttribute('aria-label', a.getAttribute('data-label') + ', ' + n + ' ' + (n === 1 ? a.getAttribute('data-one') : a.getAttribute('data-other'))); });
      D.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }));
      if (dr) {
        var m = [msg, giftMsg].filter(Boolean).join(' ');
        if (html) drawerRender(html, m); else if (m) announce(m);
        if (open) openDrawer(opener);
        return cart;
      }
      if (typeof window.SLIDECART_UPDATE === 'function') { try { window.SLIDECART_UPDATE(cart); } catch (e) {} }
      if (open && typeof window.SLIDECART_OPEN === 'function') { try { window.SLIDECART_OPEN(); } catch (e) {} }
      return cart;
    }
    function step() {
      return Promise.all([getCart(), dr ? fetchDrawer().catch(function () { return null; }) : null]).then(function (res) {
        var cart = res[0], plan = dr ? giftPlan(cart) : null;
        /* Na 3 rondes niets meer toevoegen of aanpassen; een cadeau weghalen gebeurt nog wel (tot 6 rondes), zodat de lus nooit
           eindigt met een betaalde cadeauregel (_vv_cadeau) in de winkelwagen */
        if (plan && passes >= 3) {
          if (plan.qty) plan = plan.qty.final_line_price > 0 ? { remove: [plan.qty] } : null;
          else if (!plan.remove || passes >= 6) plan = null;
        }
        if (plan) {
          passes++;
          return giftApply(plan).then(function () {
            if (plan.add) { giftMsg = dr.getAttribute('data-msg-gift-added') || ''; giftGone.drawer = false; giftGone.page = false; }
            else if (plan.remove) { giftMsg = ''; if (plan.gone) { giftGone.drawer = true; giftGone.page = true; } }
            return step();
          }, function () { return finish(cart, res[1]); });
        }
        return finish(cart, res[1]);
      });
    }
    return step();
  }
  window.vvRefreshCart = refreshCart;

  /* Aantal wijzigen, verwijderen en suggesties toevoegen in de lade */
  function drawerPost(url, body, msg) {
    var dr = drawer(); if (!dr) return;
    dr.setAttribute('aria-busy', 'true');
    var box = dr.querySelector('[data-cart-error]'); if (box) { box.hidden = true; box.textContent = ''; }
    return cartWork(postJSON(url, body)
      .then(function () { return refreshCart(false, msg); })
      .catch(function (err) {
        var m = errText(err, T('error', 'Dat lukte niet. Probeer het nog eens.'));
        var show = function () {
          var d0 = drawer(), b = d0 && d0.querySelector('[data-cart-error]');
          if (d0) $$('.loading', d0).forEach(function (x) { x.classList.remove('loading'); });
          if (b) { b.textContent = m; b.hidden = false; }
        };
        show(); announce(m);
        /* De lade kan verouderd zijn (bijv. gewijzigd in een ander tabblad, oude regelsleutels): opnieuw ophalen en de melding
           daarna weer tonen (drawerRender maakt het foutvak leeg) */
        return refreshCart(false).then(show, show);
      })
      .then(function () { var d = drawer(); if (d) d.removeAttribute('aria-busy'); }));
  }
  D.addEventListener('click', function (e) {
    var t = e.target; if (!t.closest || !window.fetch) return;
    var dr = t.closest('[data-vv-drawer]'); if (!dr) return;
    var a = t.closest('[data-cart-line],[data-cart-keys]');
    if (a) {
      e.preventDefault();
      if (a.disabled || dr.getAttribute('aria-busy') === 'true') return;
      var msg = a.getAttribute('data-msg') || dr.getAttribute('data-msg-updated'), qty = Number(a.getAttribute('data-cart-qty')) || 0;
      if (a.hasAttribute('data-cart-keys')) {
        /* Eén regel in de lade kan uit meerdere Shopify-regels bestaan (zelfde variant, gesplitst door de korting) */
        var upd = {}; a.getAttribute('data-cart-keys').split(',').forEach(function (k) { if (k) upd[k] = qty; });
        drawerPost('cart/update.js', { updates: upd }, msg);
      } else {
        drawerPost('cart/change.js', { id: a.getAttribute('data-cart-line'), quantity: qty }, msg);
      }
      return;
    }
    var ad = t.closest('[data-cart-add]');
    if (ad) {
      e.preventDefault();
      if (ad.disabled || dr.getAttribute('aria-busy') === 'true') return;
      ad.classList.add('loading');
      drawerPost('cart/add.js', { items: [{ id: Number(ad.getAttribute('data-cart-add')), quantity: Number(ad.getAttribute('data-qty')) || 1 }] }, ad.getAttribute('data-msg') || dr.getAttribute('data-msg-updated'));
    }
  });
  /* Bij het laden: klopt het cadeau niet (data-gift-sync), dan meteen corrigeren; na de terugknop (bfcache) de lade verversen */
  window.addEventListener('pageshow', function (e) { if (e.persisted && drawer()) refreshCart(false); });
  /* Terug naar dit tabblad: de winkelwagen kan in een ander tabblad gewijzigd zijn, dus de lade (en /cart) bijwerken */
  D.addEventListener('visibilitychange', function () { if (!D.hidden && drawer() && window.fetch && window.Promise) refreshCart(false).catch(function () {}); });
  D.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-quick-add]'); if (!b) return;
    e.preventDefault(); if (b.disabled) return;
    /* Meerdere maten: snelkeuze-paneel (#sheet-quick); lukt dat niet, dan naar de productpagina */
    if (b.getAttribute('data-multi') === 'true') { openQuick(b); return; }
    var id = b.getAttribute('data-quick-add'), name = b.getAttribute('aria-label') || '';
    b.disabled = true; b.classList.add('loading');
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { announce(T('added', 'Toegevoegd aan je winkelwagen.')); b.classList.add('added', 'is-added'); return refreshCart(b); })
      .catch(function (err) { announce(errText(err, T('addError', 'Toevoegen lukte niet. Probeer het nog eens.'))); })
      .then(function () { b.disabled = false; b.classList.remove('loading'); setTimeout(function () { b.classList.remove('added', 'is-added'); }, 1600); });
  });
  /* Winkelwagenknop: de eigen lade openen (meteen, en bijwerken zodra de gegevens binnen zijn: de inhoud kan verouderd zijn,
     bijv. door een ander tabblad); zonder lade Slide Cart als die er is, anders naar /cart */
  D.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-cart-open]'); if (!a) return;
    if (drawer()) { e.preventDefault(); openDrawer(a); if (window.fetch && window.Promise) refreshCart(false).catch(function () {}); return; }
    if (typeof window.SLIDECART_OPEN === 'function') { e.preventDefault(); try { window.SLIDECART_OPEN(); } catch (x) { location.href = a.href; } }
  });

  /* ---------- Snelkeuze voor maten (demo: openQuick / #sheet-quick) ----------
     Paneel: [data-vv-quick] in sections/vv-footer.liquid (teksten en bedragen als data-attributen).
     Kaartknop: [data-quick-add][data-multi="true"][data-product-handle][data-product-url] (snippets/vv-product-card).
     Haalt /products/<handle>.js en /cart.js op, toont de maten met prijs en voorraad, voegt de gekozen maat toe en opent
     Slide Cart. Zonder paneel of bij een fout: naar de productpagina. */
  var quick = null;
  function rootUrl() { return (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/'; }
  function esc(x) { return String(x == null ? '' : x).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function tok(s, map) { s = String(s || ''); for (var k in map) { if (map.hasOwnProperty(k)) s = s.split('[' + k + ']').join(map[k]); } return s; }
  function lcFirst(s) { s = String(s || ''); return s ? s.charAt(0).toLowerCase() + s.slice(1) : s; }
  function sizeText(v) { var m = String(v == null ? '' : v).trim().match(/^(\d+(?:[.,]\d+)?)\s*cm$/i); return m ? m[1] + ' cm' : String(v == null ? '' : v); }
  function imgW(src, w) { if (!src) return ''; src = String(src); if (src.indexOf('//') === 0) src = 'https:' + src; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function qAttr(n, d) { var sh = quick && quick.sheet; var v = sh ? sh.getAttribute('data-' + n) : null; return v == null ? (d || '') : v; }
  function goProduct(b) { var u = b && b.getAttribute('data-product-url'); if (u) location.href = u; }

  function openQuick(b) {
    var sh = $('[data-vv-quick]'), handle = b.getAttribute('data-product-handle');
    if (!sh || !handle || !window.fetch || !window.Promise) { goProduct(b); return; }
    if (b.getAttribute('aria-busy') === 'true') return;
    b.setAttribute('aria-busy', 'true'); b.classList.add('loading');
    var json = { headers: { Accept: 'application/json' } };
    Promise.all([
      fetch(rootUrl() + 'products/' + encodeURIComponent(handle) + '.js', json).then(function (r) { if (!r.ok) throw new Error('product'); return r.json(); }),
      fetch(rootUrl() + 'cart.js', json).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; })
    ]).then(function (res) {
      if (!renderQuick(sh, res[0], res[1], b)) { goProduct(b); return; }
      openPanel(sh, b);
    }).catch(function () { goProduct(b); })
      .then(function () { b.removeAttribute('aria-busy'); b.classList.remove('loading'); });
  }

  function renderQuick(sh, p, cart, b) {
    if (!p || !p.variants || !p.variants.length) return false;
    /* Maatoptie: de optie met meerdere waarden in cm (zoals de productkaart), anders de enige optie */
    var opts = p.options || [], oi = -1;
    for (var i = 0; i < opts.length; i++) {
      var vals = (opts[i] && opts[i].values) || [];
      if (vals.length > 1 && /cm/i.test(String(vals[0]))) { oi = i; break; }
    }
    if (oi < 0 && opts.length === 1) oi = 0;
    var vs = p.variants.map(function (v) {
      var label = oi > -1 && v.options && v.options[oi] != null ? sizeText(v.options[oi]) : (v.public_title || v.title || '');
      return { id: v.id, label: label, num: (String(label).match(/\d+(?:[.,]\d+)?/) || [''])[0], price: v.price, available: !!v.available };
    });
    quick = { sheet: sh, p: p, vs: vs, sel: 0, cart: cart, url: p.url || b.getAttribute('data-product-url') || '' };
    /* Standaard gekozen: de ingestelde maat (demo: 25 cm) als die leverbaar is, anders de eerste leverbare */
    var want = String(qAttr('default-size')).replace(/[^\d.,]/g, ''), sel = -1;
    if (want) vs.forEach(function (v, k) { if (sel < 0 && v.num === want && v.available) sel = k; });
    if (sel < 0) vs.forEach(function (v, k) { if (sel < 0 && v.available) sel = k; });
    quick.sel = sel < 0 ? 0 : sel;

    var multi = vs.length > 1, title = sh.querySelector('[data-q-title]');
    if (title) title.textContent = multi ? qAttr('title-multi', 'Kies je maat') : qAttr('title-single', 'Snel toevoegen');
    /* Foto: de echte foto die de kaart al koos (data-product-img, snippets/vv-echte-foto). Zonder dat attribuut de eerste
       productfoto waarvan de bestandsnaam niet met model, gemini of hf_ begint (geen AI-beeld of 3D-render). */
    var cardImg = b && b.getAttribute('data-product-img'), img = '';
    if (cardImg != null) img = cardImg;
    else {
      var imgs = (p.images && p.images.length ? p.images : (p.featured_image ? [p.featured_image] : []));
      for (var ii = 0; ii < imgs.length; ii++) {
        var fn = String(imgs[ii] || '').split('?')[0].split('/').pop().toLowerCase();
        if (fn && !/^(model|gemini|hf_)/.test(fn)) { img = imgW(imgs[ii], 176); break; }
      }
    }
    var lblId = 'q-size-lbl', html = '';
    html += '<div class="q-prod">' + (img ? '<img src="' + esc(img) + '" width="88" height="88" alt="" decoding="async">' : '<span></span>') +
      '<div><p class="q-name">' + esc(p.title) + '</p>' + (qAttr('meta') ? '<p class="meta">' + esc(qAttr('meta')) + '</p>' : '') + '<p class="q-price" data-q-price></p></div></div>';
    if (multi) {
      html += '<div><p class="opt-label" id="' + lblId + '">' + esc(qAttr('size-label', 'Maat')) + '</p><div class="sizes' + (vs.length === 2 ? ' two' : '') + '" role="radiogroup" aria-labelledby="' + lblId + '">';
      vs.forEach(function (v, k) {
        var gift = giftOn() && v.available && v.price >= giftMin();
        var aria = v.label + ', ' + (v.available ? money(v.price) + (gift ? ', ' + qAttr('aria-gift', 'inclusief cadeau') : '') : qAttr('sold-out', 'Uitverkocht').toLowerCase());
        html += '<button type="button" role="radio" class="size-btn' + (v.available ? '' : ' soldout') + '" data-q-size="' + k + '" aria-checked="false" tabindex="-1" aria-label="' + esc(aria) + '">' +
          (gift && qAttr('incl-gift') ? '<span class="tag" aria-hidden="true">' + esc(qAttr('incl-gift')) + '</span>' : '') +
          '<span class="s" aria-hidden="true">' + esc(v.label) + '</span><span class="p" aria-hidden="true">' + esc(v.available ? money(v.price) : qAttr('sold-out', 'Uitverkocht')) + '</span></button>';
      });
      html += '</div></div>';
    }
    if (giftOn()) html += '<p class="q-gift"><svg class="ic ic-16" aria-hidden="true" focusable="false"><use href="#i-gift"/></svg><span data-q-gift></span></p>';
    html += '<button type="button" class="btn btn-primary btn-lg btn-block" data-q-add></button>';
    html += '<p class="q-max" data-q-max role="status" hidden></p>';
    if (qAttr('ship')) html += '<p class="q-meta"><svg class="ic ic-16" aria-hidden="true" focusable="false"><use href="#i-truck"/></svg><span>' + esc(qAttr('ship')) + '</span></p>';
    if (quick.url && qAttr('details')) html += '<p><a class="link tap" href="' + esc(quick.url) + '">' + esc(qAttr('details')) + ' →</a></p>';
    var body = sh.querySelector('[data-q-body]'); if (!body) return false;
    body.innerHTML = html;
    updateQuick();
    return true;
  }
  function giftMin() { return parseInt(qAttr('gift-min'), 10) || 0; }
  function freeMin() { return parseInt(qAttr('free'), 10) || 0; }
  function giftOn() { return giftMin() > 0 && !!qAttr('gift-below'); }
  /* Demo giftMsg / giftMsgCart: wat de bezoeker met deze maat erbij krijgt */
  function quickGift(price) {
    var inCart = quick.cart ? (quick.cart.total_price || 0) : 0, t = inCart + price, g, name = qAttr('gift-name');
    if (t < giftMin()) g = tok(qAttr('gift-below'), { bedrag: money(giftMin() - t), cadeau: name });
    else if (freeMin() && t < freeMin()) g = tok(qAttr('gift-mid'), { bedrag: money(freeMin() - t), cadeau: name });
    else g = tok(qAttr('gift-top'), { cadeau: name });
    if (inCart > 0 && qAttr('gift-with')) { var pre = tok(qAttr('gift-with'), { bedrag: money(inCart) }); g = pre + (/\s$/.test(pre) ? '' : ' ') + lcFirst(g); }
    return g;
  }
  function updateQuick() {
    if (!quick) return;
    var sh = quick.sheet, v = quick.vs[quick.sel];
    $$('[data-q-size]', sh).forEach(function (btn) { var on = +btn.getAttribute('data-q-size') === quick.sel; btn.setAttribute('aria-checked', String(on)); btn.tabIndex = on ? 0 : -1; });
    var pr = sh.querySelector('[data-q-price]'); if (pr) pr.textContent = money(v.price);
    var gf = sh.querySelector('[data-q-gift]'); if (gf) gf.textContent = quickGift(v.price);
    var add = sh.querySelector('[data-q-add]');
    if (add) { add.disabled = !v.available; add.textContent = v.available ? qAttr('add', 'In winkelwagen') + ' · ' + money(v.price) : qAttr('sold-out', 'Uitverkocht'); }
    var mx = sh.querySelector('[data-q-max]'); if (mx) { mx.hidden = true; mx.textContent = ''; }
  }
  D.addEventListener('click', function (e) {
    var t = e.target; if (!t.closest || !quick) return;
    var sb = t.closest('[data-vv-quick] [data-q-size]');
    if (sb) { quick.sel = +sb.getAttribute('data-q-size') || 0; updateQuick(); return; }
    var add = t.closest('[data-vv-quick] [data-q-add]'); if (!add || add.disabled) return;
    var v = quick.vs[quick.sel], p = quick.p; if (!v || !v.available) return;
    add.disabled = true; add.classList.add('loading');
    var added = false, opn = null;
    fetch(rootUrl() + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(v.id), quantity: 1 }] })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        added = true;
        announce(tok(qAttr('added', 'Toegevoegd aan je winkelwagen: [product].'), { product: p.title + (quick.vs.length > 1 ? ', ' + v.label : '') }));
        /* Demo: snelkeuze sluiten (zonder focus terug te zetten) en de winkelwagenlade openen; na sluiten van de lade gaat
           de focus naar de kaartknop die de snelkeuze opende */
        var own = !!drawer(), hasSlide = typeof window.SLIDECART_OPEN === 'function', top = stack[stack.length - 1];
        if (top && top.el === quick.sheet) { opn = top.opener; closeTop(own || hasSlide); }
        return refreshCart((own && opn && opn.nodeType === 1) ? opn : true);
      })
      .catch(function (err) {
        var mx = quick.sheet.querySelector('[data-q-max]');
        if (added) {
          /* Wel toegevoegd, maar het bijwerken van de winkelwagen mislukte: geen foutmelding over het toevoegen. Is de snelkeuze
             al dicht, dan de focus terug op de kaartknop en de lade toch openen met deze melding in het foutvak; heeft de lade
             geen foutvak (hij was leeg), dan de snelkeuze weer openen met de melding. Sluiten zet de focus op de kaartknop. */
          var st = qAttr('added-stale', 'Toegevoegd, maar de winkelwagen kon niet worden bijgewerkt.');
          if (!inStack(quick.sheet)) {
            var card = (opn && opn.nodeType === 1 && opn.isConnected !== false) ? opn : null;
            if (card && card.focus) card.focus({ preventScroll: true });
            var d1 = drawer(), eb = d1 && d1.querySelector('[data-cart-error]');
            if (eb && openDrawer(card)) { eb = drawer().querySelector('[data-cart-error]'); if (eb) { eb.textContent = st; eb.hidden = false; } announce(st); return; }
            openPanel(quick.sheet, card);
          }
          if (mx) { mx.textContent = st; mx.hidden = false; }
          announce(st);
          return;
        }
        var msg = errText(err, qAttr('error', 'Toevoegen lukte niet. Probeer het nog eens.'));
        if (mx) { mx.textContent = msg; mx.hidden = false; }
        announce(msg);
      })
      .then(function () { add.classList.remove('loading'); if (quick && quick.vs[quick.sel]) add.disabled = !quick.vs[quick.sel].available; });
  });
  /* Pijltjestoetsen in de maatkeuze (radiogroep), zoals in de demo */
  D.addEventListener('keydown', function (e) {
    var r = e.target.closest && e.target.closest('[data-vv-quick] [role="radio"]'); if (!r) return;
    var keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }; if (!keys[e.key]) return;
    e.preventDefault();
    var rs = $$('[role="radio"]', r.parentElement), i = rs.indexOf(r);
    i = (i + keys[e.key] + rs.length) % rs.length; rs[i].click(); rs[i].focus();
  });

  /* ---------- Winkelwagenpagina (sections/vv-cart.liquid): aantal wijzigen, verwijderen en toevoegen zonder herladen ----------
     [data-vv-cart="<section-id>"] om de inhoud; a[data-cart-line="<regelsleutel>"][data-cart-qty] (href = /cart/change?... als terugval zonder JS);
     button[data-cart-add="<variant-id>"] (formaction /cart/add als terugval). De sectie wordt opnieuw opgehaald via
     de 'sections'-parameter van /cart/change.js en /cart/add.js, zodat voortgang, cadeau en totalen altijd van Shopify komen. */
  /* [data-vv-claim] ("Gratis toevoegen") is de terugval zonder JavaScript; met de lade voegt vv.js het cadeau zelf toe */
  function claimHide(root) { if (drawer()) $$('[data-vv-claim]', root).forEach(function (el) { el.hidden = true; }); }
  function cartRender(wrap, html, fk, msg) {
    var tmp = D.createElement('div'); tmp.innerHTML = html || '';
    var fresh = tmp.querySelector('[data-vv-cart]');
    if (!fresh) { location.reload(); return; }
    /* Demo #gift-notice: er zat een gratis cadeau in de winkelwagen en nu niet meer, omdat het bedrag onder de grens zit (de korting vervalt) */
    var gn = fresh.querySelector('[data-gift-notice]');
    /* ook als de winkelwagenlade (vv-cart-drawer) het cadeau net weer heeft weggehaald (giftGone.page) */
    var gone = giftGone.page && fresh.getAttribute('data-gift') === '0'; giftGone.page = false;
    if (gn && fresh.getAttribute('data-count') !== '0' && (gone || (wrap.getAttribute('data-gift-free') === '1' && fresh.getAttribute('data-gift-free') === '0' && fresh.getAttribute('data-gift') === '0'))) {
      gn.hidden = false; if (msg) msg = msg + ' ' + gn.textContent;
    }
    claimHide(fresh);
    wrap.parentNode.replaceChild(fresh, wrap);
    /* Focus terug op dezelfde knop (of op de kop als die regel weg is); niet bij een verversing van buitenaf */
    if (fk) {
      var el = fkFind(fresh, fk);
      if (!el || el.disabled || el.getAttribute('aria-disabled') === 'true') el = fresh.querySelector('[data-cart-focus]');
      if (el && el.focus) { try { el.focus({ preventScroll: true }); } catch (x) { el.focus(); } }
    }
    if (msg) announce(msg);
    return fresh;
  }
  /* Wijkt de winkelwagenpagina af van de winkelwagen (aantal, totaal of een regelsleutel die niet meer bestaat, bijv. omdat het
     cadeau erbij kwam of wegging)? */
  function cartStale(wrap, c) {
    if (String(c.item_count) !== wrap.getAttribute('data-count') || String(c.total_price) !== wrap.getAttribute('data-total')) return true;
    var keys = {}; (c.items || []).forEach(function (it) { keys[it.key] = 1; });
    return $$('[data-cart-line],[data-cart-keys]', wrap).some(function (a) {
      return String(a.getAttribute('data-cart-line') || a.getAttribute('data-cart-keys') || '').split(',').some(function (k) { return k && !keys[k]; });
    });
  }
  /* De winkelwagenpagina opnieuw ophalen. own = deze aanroep heeft de pagina zelf op aria-busy gezet (cartPost, cadeau-sync bij
     het laden): dan altijd vervangen en daarna vrijgeven. Anders (cart:refresh) niet vervangen als er intussen een actie loopt. */
  function syncCartPage(own) {
    var wrap = $('[data-vv-cart]'); if (!wrap) return Promise.resolve();
    var sid = wrap.getAttribute('data-vv-cart');
    return fetch(location.pathname + '?section_id=' + encodeURIComponent(sid), { headers: { Accept: 'text/html' } })
      .then(function (r) { if (!r.ok) throw r; return r.text(); })
      .then(function (html) {
        var cur = $('[data-vv-cart]'); if (!cur || (!own && cur.getAttribute('aria-busy') === 'true')) return;
        /* Stond de focus in de winkelwagenpagina (bijv. net op + gedrukt en daarna kwam het cadeau erbij), dan terug op dezelfde knop */
        var ae = D.activeElement, fk = (ae && ae !== cur && cur.contains(ae)) ? (ae.getAttribute('data-fk') || 'none') : null;
        cartRender(cur, html, fk, null);
      })
      .catch(function () { if (own) cartNext = []; })
      .then(function () { if (own) cartFree(); });
  }
  /* Na de verversing (en de cadeau-sync): opnieuw ophalen als de pagina afwijkt, anders alleen weer vrijgeven */
  function cartPageDone(c) {
    var cur = $('[data-vv-cart]');
    if (cur && c && c.items && cartStale(cur, c)) return syncCartPage(true);
    cartFree();
  }
  /* Klikken op + / − / Verwijderen terwijl de pagina bezig is, worden onthouden (data-fk) en daarna één voor één uitgevoerd op
     de verse knop: die heeft de nieuwe regelsleutel en het nieuwe aantal (twee keer snel op + = twee meer) */
  var cartNext = [];
  function cartFree() {
    var cur = $('[data-vv-cart]'); if (!cur) { cartNext = []; return; }
    cur.removeAttribute('aria-busy');
    var fk = cartNext.shift(); if (!fk) return;
    var el = fkFind(cur, fk);
    if (!el || el.getAttribute('aria-disabled') === 'true' || !el.matches('[data-cart-line],[data-cart-keys]')) { cartNext = []; return; }
    cartLineAct(el, cur);
  }
  /* + en − ([data-cart-line], /cart/change.js) en Verwijderen of − naar 0 bij een gesplitste regel ([data-cart-keys], /cart/update.js) */
  function cartLineAct(a, wrap) {
    var msg = a.getAttribute('data-msg') || wrap.getAttribute('data-msg-updated'), q = Number(a.getAttribute('data-cart-qty'));
    if (a.hasAttribute('data-cart-keys')) {
      var upd = {}; a.getAttribute('data-cart-keys').split(',').forEach(function (k) { if (k) upd[k] = q || 0; });
      return cartPost(wrap, 'cart/update.js', { updates: upd }, a.getAttribute('data-fk'), msg, a.getAttribute('href'));
    }
    return cartPost(wrap, 'cart/change.js', { id: a.getAttribute('data-cart-line'), quantity: q }, a.getAttribute('data-fk'), msg, a.getAttribute('href'));
  }
  function cartPost(wrap, url, body, fk, msg, fallback) {
    var sid = wrap.getAttribute('data-vv-cart');
    body.sections = [sid]; body.sections_url = location.pathname;
    wrap.setAttribute('aria-busy', 'true');
    return cartWork(fetch(rootUrl() + url, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) {
        var fresh = cartRender(wrap, j.sections && j.sections[sid], fk, msg);
        if (!fresh) return;
        /* Bezig houden tot de verversing en de cadeau-sync klaar zijn: daarna kunnen de regelsleutels anders zijn, en een tweede
           snelle klik mag geen oude sleutel versturen (die wordt onthouden en daarna op de verse knop uitgevoerd, zie cartFree) */
        fresh.setAttribute('aria-busy', 'true');
        return refreshCart(false).then(cartPageDone, function () { return cartPageDone(null); });
      })
      .catch(function (err) {
        cartNext = [];
        /* Zonder melding van Shopify (netwerkfout, storingspagina): de gewone link (werkt zonder JavaScript); anders de melding */
        var shop = !!(err && err.description), m = errText(err, T('error', 'Dat lukte niet. Probeer het nog eens.'));
        if (!shop && fallback) { wrap.removeAttribute('aria-busy'); location.href = fallback; return; }
        var show = function () { var cur = $('[data-vv-cart]'), box = cur && cur.querySelector('[data-cart-error]'); if (box) { box.textContent = m; box.hidden = false; } };
        show(); announce(m);
        /* De pagina kan verouderd zijn (oude regelsleutel, bijv. gewijzigd in een ander tabblad) of Shopify heeft een deel verwerkt
           (voorraad): bezig blijven tot de winkelwagen is bijgewerkt en de melding daarna opnieuw tonen (de pagina is dan vervangen) */
        return refreshCart(false).then(cartPageDone, function () { return cartPageDone(null); }).then(show, show);
      }));
  }
  D.addEventListener('click', function (e) {
    var t = e.target; if (!t.closest || !window.fetch) return;
    var a = t.closest('[data-vv-cart] [data-cart-line], [data-vv-cart] [data-cart-keys]');
    if (a) {
      e.preventDefault();
      if (a.getAttribute('aria-disabled') === 'true') return;
      var wrap = a.closest('[data-vv-cart]');
      /* Bezig (vorige klik of cadeau-sync): niet met een mogelijk oude regelsleutel versturen, maar onthouden en straks uitvoeren */
      if (wrap.getAttribute('aria-busy') === 'true') { var fk = a.getAttribute('data-fk'); if (fk && cartNext.length < 5) cartNext.push(fk); return; }
      cartLineAct(a, wrap);
      return;
    }
    var ad = t.closest('[data-vv-cart] [data-cart-add]');
    if (ad) {
      e.preventDefault();
      var w2 = ad.closest('[data-vv-cart]'); if (w2.getAttribute('aria-busy') === 'true') return;
      cartPost(w2, 'cart/add.js', { items: [{ id: Number(ad.getAttribute('data-cart-add')), quantity: Number(ad.getAttribute('data-qty')) || 1 }] },
        ad.getAttribute('data-fk'), ad.getAttribute('data-msg') || w2.getAttribute('data-msg-updated'), null);
    }
  });
  /* Winkelwagen elders gewijzigd (Slide Cart, snel toevoegen): de winkelwagenpagina opnieuw ophalen als de inhoud afwijkt */
  D.addEventListener('cart:refresh', function (e) {
    var wrap = $('[data-vv-cart]'), c = e.detail && e.detail.cart; if (!wrap || !c || wrap.getAttribute('aria-busy') === 'true') return;
    if (cartStale(wrap, c)) syncCartPage(false);
  });
  /* Afrekenen (lade en /cart) terwijl een wijziging of de cadeau-sync nog loopt: wachten tot alles klaar is (anders kan een cadeau
     dat nog weggehaald wordt betaald in de checkout komen) en dan versturen met de afrekenknop, zodat name=checkout meegaat.
     Eén keer: extra klikken tijdens het wachten doen niets. */
  var checkoutWait = false, checkoutGo = false;
  D.addEventListener('submit', function (e) {
    var f = e.target; if (!f.matches || !f.matches('form.vv-dr-checkout, form.vv-cart-form')) return;
    var b = e.submitter; if (b && b.name !== 'checkout') return;
    if (checkoutGo || (!checkoutWait && !cartPending)) return;
    e.preventDefault();
    if (checkoutWait) return;
    checkoutWait = true;
    var inDrawer = f.classList.contains('vv-dr-checkout'), sent = false;
    b = b || f.querySelector('button[name="checkout"]');
    if (b) b.classList.add('loading');
    var go = function () {
      if (sent) return; sent = true; checkoutWait = false;
      /* Het formulier kan intussen vervangen zijn (lade of pagina opnieuw opgehaald) */
      var cur = f.isConnected ? f : $(inDrawer ? '[data-vv-drawer] form.vv-dr-checkout' : '[data-vv-cart] form.vv-cart-form');
      var btn = cur && cur.querySelector('button[name="checkout"]');
      if (b) b.classList.remove('loading');
      if (!btn) return;
      if (cur.requestSubmit) { checkoutGo = true; try { cur.requestSubmit(btn); } finally { checkoutGo = false; } return; }
      var h = D.createElement('input'); h.type = 'hidden'; h.name = 'checkout'; h.value = btn.value || ''; cur.appendChild(h); cur.submit();
    };
    whenCartIdle(go);
    /* Blijft een verzoek hangen, dan na 10 seconden toch afrekenen */
    setTimeout(go, 10000);
  });

  /* ---------- Formulieren met een "bezig"-staat (ook na herladen van een sectie in de thema-editor) ---------- */
  D.addEventListener('submit', function (e) {
    var f = e.target; if (e.defaultPrevented || !f.matches || !f.matches('form[data-vv-form]')) return;
    var b = f.querySelector('[type="submit"]'); if (b) { setTimeout(function () { b.disabled = true; b.classList.add('loading'); }, 0); }
  });
  /* Terug naar de pagina met de terugknop: knoppen weer bruikbaar maken */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    $$('form[data-vv-form] [type="submit"].loading').forEach(function (b) { b.disabled = false; b.classList.remove('loading'); });
  });
  /* Na verzenden van een formulier: de melding (fout of bedankt) krijgt de focus, zodat hij wordt voorgelezen */
  (function () { var fx = $('[data-vv-focus]'); if (fx) { try { fx.focus({ preventScroll: true }); fx.scrollIntoView({ block: 'center' }); } catch (x) {} } })();


  /* ---------- Soepel scrollen naar een sectie: a[data-scroll="id"] ---------- */
  D.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-scroll]'); if (!a) return;
    var el = D.getElementById(a.getAttribute('data-scroll')); if (!el) return;
    e.preventDefault();
    el.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
    var h = el.querySelector('h2[tabindex],h3[tabindex]'); if (h) h.focus({ preventScroll: true });
  });

  /* ---------- Lades en panelen naar #layers verplaatsen (buiten .site, zoals in de demo) ----------
     Alles met data-vv-layer dat nog niet in #layers staat: uit #site (menu, panelen) én de winkelwagenlade, die na #site staat. */
  function moveLayers() {
    var layers = $('#layers'); if (!layers) return;
    $$('[data-vv-layer]').forEach(function (el) {
      if (layers.contains(el)) return;
      var old = $$('[data-vv-layer="' + el.getAttribute('data-vv-layer') + '"]', layers);
      old.forEach(function (o) {
        /* Stond het oude paneel open (thema-editor laadt de sectie opnieuw), dan het ook uit de stapel halen */
        for (var i = stack.length - 1; i >= 0; i--) { if (stack[i].el === o) stack.splice(i, 1); }
        syncExpanded(o, false);
        o.parentNode.removeChild(o);
      });
      layers.appendChild(el);
    });
    if (!stack.length) { var ov = $('#overlay'); if (ov && ov.classList.contains('show')) { ov.classList.remove('show'); D.documentElement.style.overflow = ''; D.documentElement.classList.remove('vv-modal-open'); var site = $('#site'); if (site) site.inert = false; } }
  }
  moveLayers();
  claimHide(D);
  /* Cadeau klopt niet bij het laden (sections/vv-cart-drawer.liquid: data-gift-sync) */
  /* Op /cart de pagina zolang bezig houden (regelsleutels kunnen veranderen) en daarna bijwerken als hij afwijkt */
  (function () {
    var dr = drawer(); if (!dr || dr.getAttribute('data-gift-sync') !== '1' || !window.fetch || !window.Promise) return;
    var w = $('[data-vv-cart]'); if (w) w.setAttribute('aria-busy', 'true');
    var p = refreshCart(false);
    if (w) cartWork(p.then(cartPageDone, function () { return cartPageDone(null); }));
  })();

  /* Valuta: de koers van Shopify bewaren als winkelwagenkenmerk _vv_fx ('SEK:11.23'), zodat de balk, de verzendkosten en het
     cadeau (snippets/vv-amount.liquid) in de valuta van de klant rekenen. Alleen bij een andere valuta dan de winkelvaluta
     en als de lade nog geen (of een oude) koers heeft. Daarna de lade twee keer verversen (de tweede keer klopt ook het
     cadeau, dat de nieuwe drempel van de lade gebruikt) en /cart opnieuw ophalen. */
  (function () {
    var dr = drawer(), c = window.Shopify && window.Shopify.currency;
    if (!dr || !c || !window.fetch || !window.Promise) return;
    var cur = dr.getAttribute('data-fx-cur'), base = dr.getAttribute('data-shop-cur'), rate = parseFloat(c.rate);
    if (!cur || !base || cur === base || c.active !== cur || !(rate > 0)) return;
    var want = cur + ':' + rate;
    if (dr.getAttribute('data-fx') === want) return;
    var w = $('[data-vv-cart]'); if (w) w.setAttribute('aria-busy', 'true');
    var again = function () { return refreshCart(false); };
    var p = cartWork(postJSON('cart/update.js', { attributes: { _vv_fx: want } }).then(again).then(again));
    var page = function () { if (w) return syncCartPage(true); };
    p.then(page, page);
  })();

  /* ---------- Markt: verlopen markt verbergen (bij een gecachete pagina) ---------- */
  function hideOldMarkets(root) {
    var today = new Date(), iso = today.getFullYear() + '-' + String(today.getMonth() + 1).padStart(2, '0') + '-' + String(today.getDate()).padStart(2, '0');
    $$('[data-vv-market][data-date]', root).forEach(function (s) { if (s.getAttribute('data-date') < iso) s.hidden = true; });
  }
  hideOldMarkets(D);

  /* ---------- Nieuwsbrief: na verzenden de melding voorlezen ---------- */
  (function () { var st = $('[data-nl-status]'); if (st) { st.focus({ preventScroll: false }); } })();

  /* ---------- Thema-editor: na het opnieuw laden van een sectie de functies opnieuw koppelen ---------- */
  D.addEventListener('shopify:section:load', function (e) {
    moveLayers(); initSpinVideos(e.target); initVideos(e.target); hideOldMarkets(e.target);
    if (e.target.querySelector && e.target.querySelector('#ann')) initAnn();
    onScroll();
    /* Winkelwagenlade opnieuw geladen terwijl hij geselecteerd is: open laten zien */
    if (e.detail && e.detail.sectionId === DRAWER_SID && drawerEditing) openDrawer(null);
  });
  /* Thema-editor: de winkelwagenlade openen zolang de sectie "VV Winkelwagenlade" geselecteerd is */
  var drawerEditing = false;
  D.addEventListener('shopify:section:select', function (e) {
    if (!e.detail || e.detail.sectionId !== DRAWER_SID) return;
    drawerEditing = true; openDrawer(null);
  });
  D.addEventListener('shopify:section:deselect', function (e) {
    if (!e.detail || e.detail.sectionId !== DRAWER_SID) return;
    drawerEditing = false; var dr = drawer();
    if (dr && stack.length && stack[stack.length - 1].el === dr) closeTop(true);
  });
  D.addEventListener('shopify:section:unload', function (e) {
    if (!e.detail || e.detail.sectionId !== DRAWER_SID) return;
    var dr = $('#layers [data-vv-drawer]');
    if (dr) { for (var i = stack.length - 1; i >= 0; i--) { if (stack[i].el === dr) stack.splice(i, 1); } dr.parentNode.removeChild(dr); }
    if (!stack.length) { var ov = $('#overlay'); if (ov) ov.classList.remove('show'); D.documentElement.style.overflow = ''; D.documentElement.classList.remove('vv-modal-open'); var site = $('#site'); if (site) site.inert = false; }
  });

  /* Toevoegen aan winkelwagen voor andere scripts (productpagina, zakelijk): items = [{id, quantity, properties}].
     open (standaard true): daarna de winkelwagenlade openen (zonder lade: Slide Cart). */
  function addToCart(items, open) {
    var opener = open === false ? false : ((open && open.nodeType === 1) ? open : (D.activeElement || true));
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) { return refreshCart(opener).then(function () { return j; }); });
  }

  /* ---------- Zoekpaneel op pagina's zonder layout vv (beleidspagina's via layout/theme.liquid) ----------
     Daar staat het paneel (sections/vv-predictive-search.liquid) en assets/vv-search.js niet op de pagina. Bij de eerste
     klik op het vergrootglas halen we beide op (Section Rendering API) en openen het paneel; lukt dat niet, dan gewoon
     naar de zoekpagina (de link). Op pagina's met layout vv doet vv-search.js alles zelf. */
  var searchLoading = false;
  D.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-vv-search-open]');
    if (!a || window.vvSearch || e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (D.getElementById('search') || !window.fetch || !window.Promise) return;
    e.preventDefault();
    var href = a.getAttribute('href') || (rootUrl() + 'search');
    if (searchLoading) return; searchLoading = true;
    fetch(rootUrl() + '?section_id=vv-predictive-search', { headers: { Accept: 'text/html' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('status'); return r.text(); })
      .then(function (html) {
        var tmp = D.createElement('div'); tmp.innerHTML = html;
        var p = tmp.querySelector('[data-vvs-panel]'), js = p && p.getAttribute('data-js');
        if (!p || !js) throw new Error('paneel');
        ($('#layers') || D.body).appendChild(p);
        return new Promise(function (ok, ko) { var s = D.createElement('script'); s.src = js; s.onload = ok; s.onerror = ko; D.head.appendChild(s); });
      })
      .then(function () { if (!window.vvSearch || !window.vvSearch.open(a)) throw new Error('open'); })
      .catch(function () { location.href = href; })
      .then(function () { searchLoading = false; });
  });

  window.vv = {
    money: money, announce: announce, openPanel: openPanel, closeTop: closeTop, initVideos: initVideos,
    initSpinVideos: initSpinVideos, spinSrc: spinSrc, apple: APPLE, reduced: reduced, saveData: saveData,
    refreshCart: refreshCart, addToCart: addToCart, openCart: openDrawer,
    top: function () { return stack.length ? stack[stack.length - 1].el : null; }
  };
})();
